<script setup>
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

// Boolean settings as rows of one bordered list: label, optional help, switch
defineProps({
  items: {
    type: Array,
    required: true,
  },
});

const modelValue = defineModel({ type: Object, required: true });

const update = (key, value) => {
  modelValue.value = { ...modelValue.value, [key]: value };
};
</script>

<template>
  <ul
    class="flex flex-col divide-y divide-n-weak rounded-xl outline outline-1 -outline-offset-1 outline-n-weak"
  >
    <li
      v-for="item in items"
      :key="item.key"
      class="flex items-center justify-between gap-4 px-4 py-3"
    >
      <div class="flex flex-col gap-0.5 min-w-0">
        <span class="text-sm text-n-slate-12">{{ item.label }}</span>
        <span v-if="item.description" class="text-xs text-n-slate-11">
          {{ item.description }}
        </span>
      </div>
      <ToggleSwitch
        :model-value="Boolean(modelValue[item.key])"
        :disabled="item.disabled"
        @update:model-value="value => update(item.key, value)"
      />
    </li>
  </ul>
</template>
